import { gql } from '@apollo/client';

export const NEWS_CATEGORY = gql`
  query getNewsCategory($input: NewsCategoryInput!) {
    getNewsCategory(input: $input) {
        id
        name
        category_id
        edit_ingress
        edit_image
    }
  }
`;